import { Alert, Button, Group, Text } from '@mantine/core'
import { IconArrowUpRight, IconHistory } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'

export function TemplateUpgrade({
  compatibility,
  upgradeInProgress,
  disabled,
  onUpgrade,
  onCancel,
}) {
  const { t } = useTranslation()
  if (upgradeInProgress) {
    return (
      <Alert color="orange" variant="light" icon={<IconHistory size={18} />}>
        <Group justify="space-between" align="center" wrap="wrap">
          <Text size="sm">
            {t('editorV2.shell.templateUpgrade.previewing')}
          </Text>
          <Button
            size="compact-xs"
            color="gray"
            variant="subtle"
            disabled={disabled}
            onClick={onCancel}
          >
            {t('editorV2.shell.templateUpgrade.cancel')}
          </Button>
        </Group>
      </Alert>
    )
  }

  const upgrade = compatibility?.upgradeOptions?.[0]
  if (!upgrade) return null

  return (
    <Alert color="blue" variant="light" icon={<IconArrowUpRight size={18} />}>
      <Group justify="space-between" align="center" wrap="wrap">
        <div>
          <Text size="sm" fw={650}>{t('editorV2.shell.templateUpgrade.available')}</Text>
          <Text size="xs" c="dimmed">
            {t('editorV2.shell.templateUpgrade.description', { name: upgrade.name, version: upgrade.version })}
          </Text>
        </div>
        <Button
          size="compact-sm"
          variant="light"
          disabled={disabled}
          onClick={() => onUpgrade(upgrade.releaseKey)}
        >
          {t('editorV2.shell.templateUpgrade.preview')}
        </Button>
      </Group>
    </Alert>
  )
}
